import React from 'react'
import Success from 'components/icons/Success.js'
import ContentNormal from 'components/elements/ContentNormal'
import { Box } from '@mui/material'
import Headline5 from 'components/elements/Headline5'

export default function RegisterSuccess() {
  return (
    <Box display={'flex'} flexDirection={'column'} gap={2} data-cy='register.sucess'>
      <Box style={{ margin: 'auto', marginTop: '10%', alignSelf: 'center', width: '100px' }}>
        <Success />
      </Box>
      <Box display={'flex'} flexDirection={'column'} alignItems={'center'} gap={1}>
        <Headline5
          translationKey="_REGISTER_SUCCESS_HEADLINE_"
          fallbackText="Tak. Din anmodning er nu sendt."
        />
        <ContentNormal className='text-center'
          translationKey="_REGISTER_SUCCESS_TEXT_"
          fallbackText="Før du kan logge ind skal en administrator godkende din bruger. Du modtager en email når dette er sket."
        />
      </Box>
    </Box>
  )
}
